/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import MainLayout from "layouts/MainLayout";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCourtLevel, fetchCourtType } from "services/basedataServices";
import { addOpeningCaseFile, editCaseCreation } from "services/caseServices";
import {
  CourtLevelBaseData,
  CourtTypeBaseData,
  DefendantCaseDetail,
  OpeniningCaseFile,
  Roles,
} from "types";
import { errorHandlerOnForm, hasRole } from "utils/helper";

const defaultValue: OpeniningCaseFile = {
  id: 0,
  defendants: [],
  status: "Pending",
  assign_prosecutor: "",
  userid_assign_prosecutor: "",
  prosecutor_registration_number: "",
  incident_registration_no: "",
  crime_refernce_number: "",
  court_type: "",
  court_level: "",
  court_registration_number: "",
  court_hearing_place: "",
  zone: "",
  city: "",
  sub_city: "",
  woreda: "",
  first_court_hearing_date: new Date(),
  reassign_prosecutor: "",
  reassign_prosecutor_userid: "",
};
const AddCourtDetail: React.FC = () => {
  const { state } = useLocation();
  const caseData: DefendantCaseDetail | null = state?.caseData || null;
  const navigate = useNavigate();
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  // const [selectedDefendant, setSelectedDefendant] = useState<Suspect>();

  const [formState, setFormState] = useState<OpeniningCaseFile>(defaultValue);
  // const [defendants, setDefendants] = useState<Suspect[]>([]);

  // const [selectedEntity, setSelectedEntity] = useState<Suspect | Witness>();
  // const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  // const [isDetailModalOpen, setIsDetailModalOpen] = useState({
  //   suspect: false,
  //   witness: false,
  // });
  const [baseData, setBaseData] = useState<{
    courtType: CourtTypeBaseData[];
    courtLevel: CourtLevelBaseData[];
  }>({
    courtType: [],
    courtLevel: [],
  });

  // useEffect(() => {
  //   if (caseData) {
  //     setFormState(caseData);
  //   }
  // }, [caseData]);

  useEffect(() => {
    fetchCourtType().then((data) =>
      setBaseData((prev) => ({ ...prev, courtType: data }))
    );
    fetchCourtLevel().then((data) =>
      setBaseData((prev) => ({ ...prev, courtLevel: data }))
    );
  }, []);

  useEffect(() => {
    if (caseData) {
      setFormState({
        ...formState,

        case: caseData?.id,
        // defendant_case_detail: caseData?.id ?? undefined,
        crime_refernce_number: caseData?.crime_refernce_number || "",
        incident_registration_no: caseData?.incident_registration_no || "",
        prosecutor_registration_number:
          caseData?.prosecutor_registration_number || "",
      });
      // setSelectedDefendant(
      //   Array.isArray(caseData?.defendants)
      //     ? (caseData.defendants as unknown[]).find(
      //         (d): d is Suspect =>
      //           typeof d === "object" && d !== null && "uu_id" in d
      //       )
      //     : undefined
      // );
    }
  }, [caseData]);

  useEffect(() => {
    if (loginData) {
      setFormState((prevState) => ({
        ...prevState,
        receiving_prosecutor: hasRole(loginData?.roles, [Roles.prosecutor])
          ? loginData?.user_id
          : null,
        receiving_police: hasRole(loginData?.roles, [Roles.member])
          ? loginData?.user_id
          : null,
      }));
    }
  }, [loginData]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formState.crime_refernce_number)
      return "Crime Reference Number is Required.";
    else if (!formState.incident_registration_no)
      return "Incident Registration Number is Required.";
    else if (!formState.prosecutor_registration_number)
      return "Prosecutor Registration Number is Required.";
    else if (!formState.court_hearing_place)
      return "Court Hearing Place is Required.";

    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }
    const formData: OpeniningCaseFile = {
      ...formState,
      status: "forwarded_to_coordinator",
      // defendants: selectedDefendant ? [selectedDefendant?.uu_id] : [],
      is_venue_changed: state?.is_venue_changed ? true : false,
    };
    addOpeningCaseFile(formData)
      .then(() => {
        if (caseData) {
          editCaseCreation({
            id: caseData?.id,
            status: "Respond_Back_cordinator",
            // Adding court details moves the case into the court-hearing stage.
            status_filter: "on_court_hearing",
          });
        }

        showTooltip("Successfully Submitted!", "success");
        navigate(-1);
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
      });
  };

  // const buildView = (data: Suspect | Witness, type: "suspect" | "witness") => {
  //   return (
  //     <div>
  //       <div className="flex flex-row mt-4 border border-[#D4D4D4] p-4 rounded-lg">
  //         <div className="flex flex-1 items-center gap-2">
  //           <img
  //             src={data?.picture || require("../../images/imageVector.png")}
  //             alt="User"
  //             className="w-10 h-10 rounded mr-2 cursor-pointer"
  //             onClick={() => {
  //               setIsImageModalOpen(true);
  //               setSelectedEntity(data);
  //             }}
  //           />
  //           <div>
  //             <p className="text-gray-800 font-semibold">{`${data?.first_name} ${data?.middle_name} ${data?.last_name}`}</p>
  //             <div className="flex flex-row gap-1 items-center">
  //               <p className="text-gray-500 text-sm">{data?.age}</p>
  //               <p>•</p>
  //               <p className="text-gray-500 text-sm">{data?.phone_number}</p>
  //               <p>•</p>
  //               <p className="text-gray-500 text-sm">{data?.nationality}</p>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="flex items-center mt-4 gap-2">
  //           <button
  //             type="button"
  //             onClick={(e) => {
  //               e.preventDefault();
  //               setIsDetailModalOpen({
  //                 suspect: type === "suspect",
  //                 witness: type === "witness",
  //               });
  //               setSelectedEntity(data);
  //             }}
  //           >
  //             {viewIcon}
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <MainLayout>
      <div className="incidentRegistration max-w-screen-lg">
        <div className="incident-title">
          <span className="text-2xl font-semibold text-gray-700">⚖ Court</span>
        </div>
        <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
          <form onSubmit={handleSubmit}>
            <div className="bg-white shadow-md rounded-lg p-6 mt-4 ">
              {/* Suspect Information */}
              <div>
                {/* <div className="flex items-center mt-4 w-[678px]">
                  Defendant
                  <hr className="flex-1 border-t border-[#E9E9E9] ml-4" />
                </div> */}
                <div>
                  {/* {selectedDefendant && buildView(selectedDefendant, "suspect")} */}

                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Crime Registration Number
                      </label>
                      <input
                        type="text"
                        placeholder="#123456"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="crime_refernce_number"
                        value={formState?.crime_refernce_number ?? ""}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Incident Registration Number
                      </label>
                      <input
                        type="text"
                        placeholder="#123456"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="incident_registration_no"
                        value={formState?.incident_registration_no ?? ""}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Prosecutor Registration Number
                      </label>
                      <input
                        type="text"
                        placeholder="#123456"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="prosecutor_registration_number"
                        value={formState?.prosecutor_registration_number ?? ""}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        First Court Hearing Date
                      </label>
                      <input
                        type="date"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="first_court_hearing_date"
                        value={
                          formState?.first_court_hearing_date
                            ? new Date(formState.first_court_hearing_date)
                                .toISOString()
                                .split("T")[0]
                            : ""
                        }
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Court Registration Number
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="court_registration_number"
                        value={formState?.court_registration_number ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Court Type
                      </label>
                      <select
                        className="border capitalize border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                        name="court_type"
                        value={formState?.court_type ?? ""}
                        onChange={handleChange}
                      >
                        <option value={""}>Select Court Type</option>
                        {baseData.courtType?.map((data, index) => (
                          <option
                            key={index}
                            value={data.type}
                            className="capitalize"
                          >
                            {data.type}
                          </option>
                        ))}
                      </select>

                      {/* <select
                        className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                        name="court_level"
                        value={formState?.court_level ?? ""}
                        onChange={handleChange}
                      >
                        <option value={""}>Select Court Level</option>
                        {Object.entries(CrimeLevel).map(([key, value]) => (
                          <option key={key} value={key}>
                            {value}
                          </option>
                        ))}
                      </select> */}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Court Level
                      </label>

                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="court_level"
                        value={formState?.court_level ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Court Hearing Place
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="court_hearing_place"
                        value={formState?.court_hearing_place ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Zone
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="zone"
                        value={formState?.zone ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        City
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="city"
                        value={formState?.city ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Sub City
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="sub_city"
                        value={formState?.sub_city ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Woreda
                      </label>
                      <input
                        type="text"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="woreda"
                        value={formState?.woreda ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-row mt-4 gap-3">
              {!caseData && (
                <input
                  type="reset"
                  className="border border-[#212121] px-[76px] py-3 text-[#747474] font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#D4D4D4]"
                  value={"Cancel"}
                />
              )}
              <input
                type="submit"
                className="border border-[#212121] bg-[#212121] px-[76px] py-3 text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]"
                value={caseData ? "Save" : "Finish"}
              />
            </div>
          </form>
        </div>
      </div>
      {/* {isImageModalOpen && (
        <ImageModal
          isOpen={isImageModalOpen}
          imageSrc={
            selectedEntity?.picture || require("../../images/imageVector.png")
          }
          label={
            selectedEntity?.first_name +
            " " +
            selectedEntity?.last_name +
            " " +
            selectedEntity?.last_name
          }
          onClose={() => setIsImageModalOpen(false)}
        />
      )}
      {isDetailModalOpen?.suspect && (
        <SuspectDetailInfo
          suspect={selectedEntity as Suspect}
          isOpen={isDetailModalOpen?.suspect}
          onClose={() =>
            setIsDetailModalOpen({
              suspect: false,
              witness: false,
            })
          }
        />
      )}
      {isDetailModalOpen?.witness && (
        <WitnessOnlyDetail
          witness={selectedEntity as Witness}
          isOpen={isDetailModalOpen?.witness}
          onClose={() =>
            setIsDetailModalOpen({ suspect: false, witness: false })
          }
        />
      )} */}
    </MainLayout>
  );
};

export default AddCourtDetail;
